import axios from "axios";

axios.defaults.withCredentials = true;

const httpClient = axios.create();
// timeout à 60 seconde
httpClient.defaults.timeout = 60000;

export default {
  /**
   * Récupération de le référentiel Type Souscription
   * - renvoie un objet vide si non connecté
   */
  async getAgentIndividu() {
    const individu = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_AGENT_INDIVIDU
    );
    return individu.data;
  },
  async getDrhIndividu(noSiRh) {
    const individu = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_DRH_INDIVIDU +
        "/" +
        noSiRh
    );
    return individu.data;
  },
  async getAgentListeEmploi() {
    // utilisation timeout 60 sec si lenteur du WS WPPRH
    const individu = await httpClient.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_AGENT_LISTE_EMPLOI
    );
    return individu.data;
  },
  async getDrhListeEmploi(noSiRh) {
    // utilisation timeout 60 sec si lenteur du WS WPPRH
    const individu = await httpClient.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_DRH_LISTE_EMPLOI +
        "/" +
        noSiRh
    );
    return individu.data;
  },

  async getDateContrat() {
    return (
      await httpClient.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_AGENT_DATE_CONTRAT
      )
    ).data;
  },

  async getDRHDateContrat(noSIRH) {
    return (
      await httpClient.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_DRH_DATE_CONTRAT +
          "/" +
          noSIRH
      )
    ).data;
  },

  async getAllContratCarrieres() {
    return (
      await httpClient.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_ADMIN_CONTRAT_CARRIERES
      )
    ).data;
  },

  async saveAllContratCarrieres(contratCarrieres) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_ADMIN_CONTRAT_CARRIERES,
        contratCarrieres
      )
    ).data;
  },

  async saveContratCarriere(contratCarriere) {
    return (
      await axios.post(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_ADMIN_CONTRAT_CARRIERES,
        contratCarriere
      )
    ).data;
  },

  async deleteContratCarriere(id) {
    return (
      await axios.delete(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_ADMIN_CONTRAT_CARRIERES +
          "/" +
          id
      )
    ).data;
  },
};
